import LegalDoc from "@/components/LegalDoc";
import { CONDICIONES } from "@/data/condiciones";

export default function CondicionesVenta() {
  return <LegalDoc doc={CONDICIONES} testId="condiciones-page" />;
}
